export const isPersian = (str) => {
    const lang = /^[\u0600-\u06FF\s]+$/;

    if (lang.test(str[0])) {
        return true;
    } else {
        return false;
    }
};
